import Button from "pages/_components/Button";
import CustomData from "pages/_components/CustomData/CustomData";
import FormattedAmount from "pages/_components/FormattedAmount";
import I18n from "pages/_components/I18n";
import Image from "pages/_components/Image";
import { bool, func, number, shape, string } from "prop-types";
import React from "react";
import * as i18nUtils from "util/i18n";

const LinesInfo = ({ validLines, invalidLines, totalAmount, downloadFile, linesInfoMessage }) => {
    const isWarningOneLine = invalidLines === 1;
    const isWarning = invalidLines >= 1;
    const srcIcon = isWarning ? "images/figma/icon/warning.svg" : "images/figma/icon/success.svg";
    return (
        <>
            <div className={`detailBox-data ${!isWarning && !isWarningOneLine ? "file-success-format" : ""}`}>
                <div className="detailBox-lines">
                    <div className={`icon-medium btn-only-icon btn ${isWarning ? "tag-warning" : "tag-success"}`}>
                        <Image src={srcIcon} className="svg-icon" />
                    </div>
                    <div>
                        <strong className="primary">
                            {i18nUtils.get(linesInfoMessage, null, {
                                validLines,
                                totalLines: validLines + invalidLines,
                            })}
                        </strong>
                        <div className="small primary">
                            {isWarning && (
                                <I18n
                                    id="forms.inputFile.massivePayments.invalid.lines.warning"
                                    invalidLines={invalidLines}
                                />
                            )}
                            {isWarningOneLine && (
                                <I18n
                                    id="forms.inputFile.massivePayments.invalid.line.warning"
                                    invalidLines={invalidLines}
                                />
                            )}
                        </div>
                    </div>
                </div>
                <div className="horizontal-divider lg:hidden" />
                <div className="detailBox-amount">
                    <CustomData
                        dataClass="custom-data-title primary to-end"
                        titleText="forms.inputFile.massivePayments.totalAmount"
                        titleTextType="I18N"
                        valueText={<FormattedAmount className="data-desc" {...totalAmount} notBold="true" />}
                    />
                </div>
            </div>
            <div>
                {(isWarning || isWarningOneLine) && (
                    <>
                        <div className="detailBox-data-footer">
                            <div className="horizontal-divider" />
                            <div className="detailBox-download-errors">
                                <I18n id="forms.inputFile.massivePayments.calculated.amount.info" />
                            </div>
                            <Button
                                className="btn-link px-0"
                                onClick={() => downloadFile({ isDownloadingRelatedFile: true })}
                                image="images/figma/icon/download.svg"
                                label="global.download"
                                block={false}
                            />
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

LinesInfo.propTypes = {
    validLines: number.isRequired,
    invalidLines: number.isRequired,
    totalAmount: shape({
        currency: string.isRequired,
        quantity: number.isRequired,
    }).isRequired,
    downloadFile: func.isRequired,
    isDesktop: bool.isRequired,
    linesInfoMessage: bool,
};

LinesInfo.defaultProps = {
    linesInfoMessage: "forms.inputFile.massivePayments.success",
};

export default LinesInfo;
